import { ParamMap } from '@angular/router';
import { ListArgs } from 'src/shared/api';
import * as moment from 'moment';

export function hasAnyParams(paramMap: ParamMap): boolean {
	return paramMap && paramMap.keys.length > 0;
}

export function hasNoParams(paramMap: ParamMap): boolean {
	return paramMap && paramMap.keys.length === 0;
}

export function isMissingPagingArgs(listArgs: ListArgs): boolean {
	return !listArgs || !listArgs.pageSize;
}

export function isMissingOrInvalidStartingSunday(listArgs: {
	startingSunday?: string;
}): boolean {
	return (
		!listArgs.startingSunday ||
		!moment.utc(listArgs.startingSunday).isValid() ||
		moment.utc(listArgs.startingSunday).day() !== 0
	);
}
